// External deps

import PropTypes from 'prop-types';
import { Button, SelectGeneric, Label } from 'ypf-pas-general-ui-components';

// Internal deps
import useMonthlyApprovers from '../../../../../../hooks/useMonthlyApprovers';
import './MonthlyAddApproversForm.scss';
import { DetailRequestMonthly } from '../../../../../../utils/globalPropTypes';

const MonthlyAddApproversForm = ({
  currentApprovers,
  details,
  hideForm,
  fetchApprovers,
  setLocalLoader
}) => {
  const isOyM = details?.operacion?.length > 0;
  const {
    values,
    optionApprover,
    teamOptions,
    serviceOptions,
    contractOptions,
    setFieldValue,
    resetForm,
    addApprover
  } = useMonthlyApprovers({
    currentApprovers,
    details,
    hideForm,
    fetchApprovers,
    setLocalLoader,
    isOyM
  });

  return (
    <>
      <div>
        <div className="monthly-add-approvers-form">
          <div className="field approver-field">
            <Label label="Aprobador" />
            <SelectGeneric
              heigthSelect={40}
              name="approver"
              onChange={(val) => {
                setFieldValue('approver', val);
                setFieldValue('team', null);
                setFieldValue('service', null);
                setFieldValue('contract', null);
              }}
              options={optionApprover}
              placeholder="Buscar nombre"
              value={values?.approver}
              withSelect="100%"
            />
          </div>
          <div className="field team-field">
            <Label label="Equipo" />
            <SelectGeneric
              clearable
              defaultValue={null}
              defaultValueOneOption={false}
              heigthSelect={40}
              isDisabled={!values?.approver?.value}
              name="team"
              onChange={(val) => setFieldValue('team', val)}
              options={teamOptions}
              placeholder="Buscar equipo"
              value={values?.team}
              withSelect="100%"
            />
          </div>
          <div className="field service-field">
            <Label label="Servicio" />
            <SelectGeneric
              clearable
              defaultValue={null}
              defaultValueOneOption={false}
              heigthSelect={40}
              isDisabled={!values?.approver?.value}
              name="service"
              onChange={(val) => setFieldValue('service', val)}
              options={serviceOptions}
              placeholder="Buscar servicio"
              value={values?.service}
              withSelect="100%"
            />
          </div>
          <div className="field contract-field">
            <Label label="Contrato" />
            <SelectGeneric
              clearable
              defaultValue={null}
              defaultValueOneOption={false}
              heigthSelect={40}
              isDisabled={!values?.approver?.value}
              name="contract"
              onChange={(val) => setFieldValue('contract', val)}
              options={contractOptions}
              placeholder="Buscar contrato"
              value={values?.contract}
              withSelect="100%"
            />
          </div>
          <div className="buttons">
            <Button
              label="Cancelar"
              onClick={() => {
                hideForm();
                resetForm();
              }}
              type="button"
              variant="outline-primary"
            />
            <Button
              disabled={
                !(
                  values?.approver?.value &&
                  (values?.team?.value || values?.service?.value || values?.contract?.value)
                )
              }
              label="Agregar"
              onClick={addApprover}
              type="button"
              variant="primary"
            />
          </div>
        </div>
      </div>
      <hr className="divide-line" />
    </>
  );
};

export default MonthlyAddApproversForm;

MonthlyAddApproversForm.propTypes = {
  details: DetailRequestMonthly.isRequired,
  currentApprovers: PropTypes.arrayOf(PropTypes.shape({})),
  hideForm: PropTypes.func,
  fetchApprovers: PropTypes.func,
  setLocalLoader: PropTypes.func
};

MonthlyAddApproversForm.defaultProps = {
  currentApprovers: [],
  hideForm: () => {
    /* Empty */
  },
  fetchApprovers: () => {
    /* Empty */
  },
  setLocalLoader: () => {
    /* Empty */
  }
};
